import { render, staticRenderFns } from "./DealerInformation.vue?vue&type=template&id=20383780&scoped=true&"
import script from "./DealerInformation.vue?vue&type=script&lang=js&"
export * from "./DealerInformation.vue?vue&type=script&lang=js&"
import style0 from "./DealerInformation.vue?vue&type=style&index=0&id=20383780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20383780",
  null
  
)

export default component.exports